var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRelacionado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.14 16.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#534741;}.cls-2{font-size:12px;fill:#fff;font-family:IowanOldStyle-Roman, Iowan Old Style;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WEB_VIEW",
    "data-name": "WEB VIEW"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 7.07,
    cy: 7.07,
    r: 7.07
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3.54 11.37)"
  }, "R")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelacionado);
export default __webpack_public_path__ + "static/media/Relacionado.a344aeff9e6efe57683f8985782acfa8.svg";
export { ForwardRef as ReactComponent };